import { Modal } from "bootstrap";
//import { Select2Helper } from "./Select2Helper";
import { CommonHelper } from "./CommonHelper";

export class ModalHelper {

    private modalContainer;
    private modal : Modal;

    public createModal(modalId: string, isFullScreen:boolean = true) {
        var modalContainer: any;

        modalContainer = $(`#${modalId}`);

        if (modalContainer.length > 0) {
            this.modalContainer = modalContainer;
            return modalContainer;
        }

        var createdModalContainer = $(document.createElement("div"));

        createdModalContainer.addClass('modal');
        createdModalContainer.addClass('fade');
        createdModalContainer.attr('id', modalId);
        createdModalContainer.attr('role', 'dialog');

        this.modalContainer = createdModalContainer;
    }

    public load(url:string, modalLoadedFunction?: () => void, modalShownFunction?: () => void, modalHiddenFunction?: () => void) {
        var self = this;

        if(this.modalContainer === undefined || this.modalContainer === null) {
            throw new Error('No modal created. Invoke CreateModal first.');
        } 

        this.modalContainer.load(url, () => {
            self.modalLoaded(modalLoadedFunction, modalShownFunction, modalHiddenFunction);
        });
    }

    public loadWithPost(url:string, parameters:any, modalLoadedFunction?: () => void, modalShownFunction?: () => void, modalHiddenFunction?: () => void) {
        var self = this;

        if(this.modalContainer === undefined || this.modalContainer === null) {
            throw new Error('No modal created. Invoke CreateModal first.');
        } 

        this.modalContainer.load(url, parameters, () => {
            self.modalLoaded(modalLoadedFunction, modalShownFunction, modalHiddenFunction);
        });
    }

    public loadFromHtml(html:string, modalLoadedFunction?: () => void, modalShownFunction?: () => void, modalHiddenFunction?: () => void, zIndex: number | undefined = undefined) {
        var self = this;

        if(this.modalContainer === undefined || this.modalContainer === null) {
            throw new Error('No modal created. Invoke CreateModal first.');
        } 

        this.modalContainer.html(html);
        self.modalLoaded(modalLoadedFunction, modalShownFunction, modalHiddenFunction, zIndex);
    }

    private modalLoaded(modalLoadedFunction?: () => void, modalShownFunction?: () => void, modalHiddenFunction?: () => void, zIndex: number | undefined = undefined) {
        var self = this;

        this.modal = new Modal(this.modalContainer, {
            backdrop: 'static',
            keyboard: true,
            focus: false,
        });

        this.modal.show();

        if(modalLoadedFunction !== undefined) {
            modalLoadedFunction();
        }

        var intervalTimer;
        var setBackgroundFunc = () => {
            var prevObject = this.modalContainer.prev();

            if(zIndex == undefined) {
                clearInterval(intervalTimer);
            }

            if(zIndex != undefined && prevObject.hasClass('modal-backdrop')) {
                this.modalContainer.css('z-index', zIndex);
                this.modalContainer.prev().css('z-index', (zIndex-1));
                clearInterval(intervalTimer);
            }
        };

        intervalTimer = setInterval(setBackgroundFunc, 1);

        var defaultModalShownBindings = () => {
            //ModalHelper.bindDraggableToModal(this.modalContainer);
            CommonHelper.bindDisablingSaveButton();
            CommonHelper.bindDeleteSaveButton();

            // this.modalContainer.find('select.select2').each((index, element) => {
            //     var selectElement = $(element);
            //     Select2Helper.BindSelect2Input(selectElement);
            // });


        }

        if(modalShownFunction !== undefined) {
            this.modalContainer.off('shown.bs.modal').on('shown.bs.modal', () => {
                defaultModalShownBindings();

                modalShownFunction();
            });
        }
        else {
            this.modalContainer.off('shown.bs.modal').on('shown.bs.modal', () => {
                defaultModalShownBindings();
            });

        }

        this.modalContainer.find('[data-bs-toggle="tooltip"]').tooltip();

        this.modalContainer.off('hidden.bs.modal').on('hidden.bs.modal', () => {
            if(modalHiddenFunction !== undefined) {
                modalHiddenFunction();
            }

            this.disposeModal();
        });

        $(document).on('keyup',function(evt) {
            if (evt.keyCode == 27) {
                self.hideModal();
            }   
        });
    }

    public getModalContainer() : any {
        return this.modalContainer;
    }

    public disposeModal() {
        if(this.modalContainer === undefined || this.modalContainer === null || this.modal === null) {
            throw new Error('No modal created. Unable to dispose.');
        } 
        
        this.modalContainer.remove();
        this.modal.dispose();

    }

    public hideModal() {
        if(this.modalContainer === undefined || this.modalContainer === null || this.modal === null) {
            throw new Error('No modal created. Unable to hide.');
        } 

        this.modal.hide();
    }

    
    // public static bindDraggableToModal(modalContainer) {
    //     if (modalContainer.length == 0) {
    //         return;
    //     }

    //     modalContainer.find('.modal-header').off('mousedown').on('mousedown', function (de) {

    //         var draggable = $(this);

    //         var x = de.pageX - draggable.offset().left;
    //         var y = de.pageY - draggable.offset().top;

    //         $('body').on('mousemove.draggable', function (me) {
    //             draggable.closest('.modal-dialog').offset({
    //                 'left': me.pageX - x,
    //                 'top': me.pageY - y
    //             });
    //         })

    //         $('body').on('mouseup', function () {
    //             $('body').off('mousemove.draggable');
    //         });

    //         draggable.closest('.modal').one('bs.modal.hide', function () {
    //             $('body').off('mousemove.draggable');
    //         });
    //     });
    // }

    // public static bindDraggableModal() {
    //     this.bindDraggableToModal($('.modal'));
    // }
}

